import { render, staticRenderFns } from "./BeneficiaryDetails.vue?vue&type=template&id=0a7bff36&scoped=true&"
import script from "./BeneficiaryDetails.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryDetails.vue?vue&type=script&lang=js&"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=0a7bff36&scoped=true&lang=css&"
import style1 from "./BeneficiaryDetails.vue?vue&type=style&index=1&id=0a7bff36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7bff36",
  null
  
)

export default component.exports